import styles from "./Common.module.css"
import {boxType, options} from "./const";

export default function TopBar({title, value, setValue, count, setCount, add, step}) {
    const handleChange = (e, step, target) => {
        target === 'value' ? setValue(prev => ({
            ...prev,
            [step]: e.target.value
        })) : setCount(prev => ({
            ...prev,
            [step]: e.target.value
        }))
    }
    return (
        <section className={styles.topBar}>
            <span>{title}</span>
            {count ?
                <div className={styles.container}>
                    <select defaultValue={boxType[0].key} value={value[step]}
                            className={`${styles.dropdown} inputBorder inputTextAreaMargin`}
                            onChange={(e) => handleChange(e, step, 'value')}>
                        {boxType?.map((option, index) => (
                            <option value={option.key} key={`TBqwer${index}`} disabled={index === 0}>
                                {option.label}</option>))}
                    </select>
                    <select value={count[step]} className={`${styles.dropdown} inputBorder inputTextAreaMargin`}
                            onChange={(e) => handleChange(e, step, 'second')}>
                        <option disabled value={-1}>갯수</option>
                        {Array(4).fill(0).map((option, index) => (
                            <option value={index} key={`TBasdf${index}`}>{index + 2}개</option>))}
                    </select>
                    <button className={`blackButton`} onClick={() => add(step)}>추가
                    </button>
                </div>
                : value ? <div className={styles.container}>
                        <select value={value} className={`${styles.dropdown} inputBorder inputTextAreaMargin`}
                                onChange={(e) => setValue(e.target.value)}>
                            <option value={-1} disabled>선택하세요.</option>
                            {options.filter((_, index) =>
                                title === '설문' ? index >= 2 : index <= 2)
                                .map((option, index) => (
                                    <option value={option.label} key={`TBzxcv${index}`}>{option.label}</option>))}
                        </select>
                        <button onClick={add}>추가</button>
                    </div>
                    : add ? <button onClick={add}>추가</button> : null}
        </section>
    )
}